import React, { useState, useEffect, useRef } from "react";
import { useAuth0 } from '@auth0/auth0-react';
import { useNavigate } from 'react-router-dom';
import Sidebar from "./Sidebar";

const FloorPlan = () => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);

    

  return (
    <div>
       <Sidebar isSidebarOpen={isSidebarOpen} setIsSidebarOpen={setIsSidebarOpen} />
      
         
      

             
               <div className="px-6 lg:px-10 pt-10 xl:px-8 2xl:px-8 pb-6">
        {/* viewer section */}
        <div className="rounded-xl border border-[#E2E2E4] shadow-[0_1px_2px_0_#dedede] bg-white">
          {/* title*/}
          <div className="px-8 pt-6 mb-4">
            <p className="lg:text-3xl md:text-2xl sm:text-xl text-[22px] font-bold pb-2">
              Floor Plan
            </p>
          </div>

          {/* iframe container - removed horizontal padding to make it full width */}
          <div className="w-full px-6 pb-4">
            <div className="relative w-full" style={{ paddingTop: "52.25%" }}>
              <iframe 
                src="https://pwwpdev.github.io/pag.html"
                className="absolute top-0 left-0 w-full h-full border-0"
                title="Floor Plan Viewer"
              />
            </div>
          </div> 
        </div> 
      </div>
    </div>
  );
};

export default FloorPlan;